var image_upload_default = {
  "container": "kxm-C",
  "disabled": "_38RnZ",
  "imageInput": "CPR2Z",
  "overlay": "AcGCa",
  "text": "UorX5",
  "shown": "QdZmE",
  "hide": "oRopk",
  "spinner": "nSTWN",
  "spin": "_0vBTC"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
